
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/go",
      function () {
        return require("private-next-pages/events/sdks/go.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/go"])
      });
    }
  